import Breadcrumb from "../Component/Breadcrumb";
const Ptm = () => {
  return (
    <>
      <Breadcrumb
        breadtitle="School Fee"
        breadmid="Admission"
        breadend="School Fee"
      />
      <div className="innerpage">
        <div className="container">
          <div className="row">
            <div class="col-12">
              <p>
                This is an unaided Minority Institution having Minority Status
                Certificate and it does not receive any aid either from the
                Government or any other source. Salaries and other expenses are
                met from the fees charged from the students.
              </p>
              <h4>Fee Rules:</h4>
              <ul className="list-view mb-4">
                <li>
                  Fees will be deposited at the Bank of Baroda, Munshipulia
                  Indira Nagar branch from 5th to 15th of the next month, and
                  with late fees <b>Rs. 50/- </b>from 1st to 5th month as given
                  on the next page and on the Fee Bill Book. If the fee is not
                  deposited even on the due dates of late fees submission, (from
                  1-5th of the following month with a fine of <b>Rs. 50/-)</b> a
                  fine of <b>Rs. 200/-</b> will be charged per installment.
                </li>
                <li>No Fees will be accepted in the school office.</li>
                <li>
                  Parents are requested to deposit the fees regularly without
                  reminders from the school.
                </li>
                <li>All arrears must be cleared before assessments.</li>
                <li>For details of payment, kindly refer to the fee book.</li>
                <li>
                  Fees can be paid in cash or cheque. If the last day (15th of
                  the Month) falls on a holiday or Sunday, fees will be accepted
                  on the following working day.
                </li>
                <li>
                  No student will be issued any certificate unless all dues are
                  cleared.
                </li>
              </ul>

              <div class="clr10"></div>
              <h4>Fee Structure</h4>
              <h5 className="mb-4">
                {" "}
                <span>Fee Structure 2025-2026</span>
              </h5>
              <ul className="list-view mb-4">
                <li>
                  Fee Structure for Academic Session 2025-2026{" "}
                  <a
                    href="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/CSFL/public/pdf/Fee-Structure-25-26.pdf"
                    target="_blank"
                  >
                    <b>Click here</b>
                  </a>
                </li>
              </ul>

              <h5 className="mb-4">
                {" "}
                <span>Fee Structure 2024-2025</span>
              </h5>
              <ul className="list-view mb-4">
                <li>
                  Fee Structure for Academic Session 2024-2025{" "}
                  <a
                    href="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/CSFL/public/pdf/Fee-Structure.pdf"
                    target="_blank"
                  >
                    <b>Click here</b>
                  </a>
                </li>
              </ul>

              <h5 className="mb-4">
                {" "}
                <span>Fee Structure 2023-2024</span>
              </h5>
              <ul className="list-view mb-4">
                <li>
                  Fee Structure for Academic Session 2023-2024{" "}
                  <a
                    href="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/CSFL/public/pdf/fee-structure-2023-24.pdf"
                    target="_blank"
                  >
                    <b>Click here</b>
                  </a>
                </li>
              </ul>
              <div class="clr10"></div>

              <h5 className="mb-4">
                {" "}
                <span>Fee Structure 2022-2023</span>
              </h5>
              <ul className="list-view mb-4">
                <li>
                  Fee Structure for Academic Session 2022-2023 (NUR-XII){" "}
                  <a
                    href="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/CSFL/public/pdf/FEE-STRUCTURE-2022-2023(NUR-XII).pdf"
                    target="_blank"
                  >
                    <b>Click here</b>
                  </a>
                </li>
              </ul>
              <div class="clr10"></div>
              <h5 className="mb-4">
                {" "}
                <span>Fee Structure 2021-2022</span>
              </h5>
              <ul className="list-view mb-4">
                <li>
                  Fee Structure (Reduced)for Academic Session (2021 - 2022){" "}
                  <a
                    href="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/CSFL/public/pdf/Fee-2021-22-reduced.pdf"
                    target="_blank"
                  >
                    <b>Click here</b>
                  </a>
                </li>
                <li>
                  Fee Chart for the Year 2021–2022: Class Nur - XII{" "}
                  <a
                    href="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/CSFL/public/pdf/Fee-2021-22.pdf"
                    target="_blank"
                  >
                    <b>Click here</b>
                  </a>
                </li>
              </ul>
              <div class="clr10"></div>
              <h5 className="mb-4">
                {" "}
                <span>Fee Structure 2020-2021</span>
              </h5>
              <ul className="list-view mb-4">
                <li>
                  Fee Chart for the Year 2020–2021: Class Nur - K.G{" "}
                  <a
                    href="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/CSFL/public/pdf/Fee-Nur-KG-20-21.pdf"
                    target="_blank"
                  >
                    <b>Click here</b>
                  </a>
                </li>
                <li>
                  Fee Chart for the Year 2020–2021: Class I - II{" "}
                  <a
                    href="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/CSFL/public/pdf/Fee-I-II-20-21.pdf"
                    target="_blank"
                  >
                    <b>Click here</b>
                  </a>
                </li>
                <li>
                  Fee Chart for the Year 2020–2021: Class III - V{" "}
                  <a
                    href="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/CSFL/public/pdf/Fee-III-IV-V-20-21.pdf"
                    target="_blank"
                  >
                    <b>Click here</b>
                  </a>
                </li>
                <li>
                  Fee Chart for the Year 2020–2021: Class VI - VII{" "}
                  <a
                    href="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/CSFL/public/pdf/Fee-VI-VII-20-21.pdf"
                    target="_blank"
                  >
                    <b>Click here</b>
                  </a>
                </li>
                <li>
                  Fee Chart for the Year 2020–2021: Class VIII{" "}
                  <a
                    href="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/CSFL/public/pdf/Fee-VIII-20-21.pdf"
                    target="_blank"
                  >
                    <b>Click here</b>
                  </a>
                </li>
                <li>
                  Fee Chart for the Year 2020–2021: Class IX - X{" "}
                  <a
                    href="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/CSFL/public/pdf/Fee-IX-X-20-21.pdf"
                    target="_blank"
                  >
                    <b>Click here</b>
                  </a>
                </li>
                <li>
                  Fee Chart for the Year 2020–2021: Class XI - XII (Commerce){" "}
                  <a
                    href="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/CSFL/public/pdf/Fee-XI-XII(Comm)-20-21.pdf"
                    target="_blank"
                  >
                    <b>Click here</b>
                  </a>
                </li>
                <li>
                  Fee Chart for the Year 2020–2021: Class XI - XII (Commerce
                  with comp){" "}
                  <a
                    href="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/CSFL/public/pdf/Fee-XI-XII-Comm-with-com-20-21.pdf"
                    target="_blank"
                  >
                    <b>Click here</b>
                  </a>
                </li>
                <li>
                  Fee Chart for the Year 2020–2021: Class XI - XII (Science){" "}
                  <a
                    href="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/CSFL/public/pdf/Fee-XI-XII(Sci)-20-21.pdf"
                    target="_blank"
                  >
                    <b>Click here</b>
                  </a>
                </li>
                <li>
                  Fee Chart for the Year 2020–2021: Class XI - XII (Science with
                  comp){" "}
                  <a
                    href="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/CSFL/public/pdf/Fee-XI-XII-Sci-with-com-20-21.pdf"
                    target="_blank"
                  >
                    <b>Click here</b>
                  </a>
                </li>
                <li>
                  Fee Chart for the Year 2020-2021: Class Nur - XII{" "}
                  <a
                    href="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/CSFL/public/pdf/FEE-2020-21.pdf"
                    target="_blank"
                  >
                    <b>Click here</b>
                  </a>
                </li>
              </ul>
              <div class="clr10"></div>
              <h5 className="mb-4">
                {" "}
                <span>Fee Structure 2019-2020</span>
              </h5>
              <ul className="list-view mb-4">
                <li>
                  Fee Chart for the Year 2019-2020: Class Nur - K.G{" "}
                  <a
                    href="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/CSFL/public/pdf/Nur - K.G.pdf"
                    target="_blank"
                  >
                    <b>Click here</b>
                  </a>
                </li>
                <li>
                  Fee Chart for the Year 2019-2020: Class I - II{" "}
                  <a
                    href="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/CSFL/public/pdf/1 &amp; II.pdf"
                    target="_blank"
                  >
                    <b>Click here</b>
                  </a>
                </li>
                <li>
                  Fee Chart for the Year 2019-2020: Class III-V{" "}
                  <a
                    href="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/CSFL/public/pdf/III TO V.pdf"
                    target="_blank"
                  >
                    <b>Click here</b>
                  </a>
                </li>
                <li>
                  Fee Chart for the Year 2019-2020: Class VI-VII{" "}
                  <a
                    href="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/CSFL/public/pdf/VI TO VII.pdf"
                    target="_blank"
                  >
                    <b>Click here</b>
                  </a>
                </li>
                <li>
                  Fee Chart for the Year 2019-2020: Class VIII{" "}
                  <a
                    href="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/CSFL/public/pdf/VIII.pdf"
                    target="_blank"
                  >
                    <b>Click here</b>
                  </a>
                </li>
                <li>
                  Fee Chart for the Year 2019-2020: Class IX - X{" "}
                  <a
                    href="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/CSFL/public/pdf/IX - X.pdf"
                    target="_blank"
                  >
                    <b>Click here</b>
                  </a>
                </li>
                <li>
                  Fee Chart for the Year 2019-2020: Class XI - XII (Comm.){" "}
                  <a
                    href="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/CSFL/public/pdf/XI - XII Comm. with com..pdf"
                    target="_blank"
                  >
                    <b>Click here</b>
                  </a>
                </li>
                <li>
                  Fee Chart for the Year 2019-2020: Class XI - XII (Sci.){" "}
                  <a
                    href="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/CSFL/public/pdf/XI - XII Sci with com..pdf"
                    target="_blank"
                  >
                    <b>Click here</b>
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default Ptm;
